export const LECTURE_STUDIO_COURSES = "https://lecture.studio/ekrcet/courses";

/** Courses that used to live at /course/<id> on this site, now hosted on Lecture Studio. */
export const LECTURE_STUDIO_COURSE_PAGES: Record<string, string> = {
  yzm1022: "https://lecture.studio/ekrcet/yzm1022-advanced-programming",
  yzm2011: "https://lecture.studio/ekrcet/yzm2011-intro-to-machine-learning",
  yzm2021:
    "https://lecture.studio/ekrcet/yzm2021-principles-of-software-engineering",
};
